import React, { useId } from 'react';
import { brandLogoSrc } from '../data/landing';
type BrandLogoProps = {
  className?: string;
  title?: string;
};

/**
 * Brand mark (placeholder): renders the uploaded logo image as a transparent,
 * single-color icon. Light pixels of the source become the mark, the darker
 * background is knocked out, and the result is filled with currentColor —
 * so it shows white over the dark hero/footer and dark on light sections.
 *
 * Placeholder artwork credit: "Letter L" by Nakulah.design.
 */
export function BrandLogo({
  className = '',
  title
}: BrandLogoProps) {
  const uid = useId().replace(/:/g, '');
  const filterId = `logo-knockout-${uid}`;
  const maskId = `logo-mask-${uid}`;
  return <svg viewBox="28 18 920 954" role={title ? 'img' : undefined} aria-hidden={title ? undefined : true} aria-label={title} className={className} data-id="element-44" data-mp="23sfbeoo8u4ns">
      <defs data-id="element-45" data-mp="9exlww4a2xq4">
        <filter id={filterId} colorInterpolationFilters="sRGB" data-id="element-46" data-mp="9fh5eh9ktu69">
          {/* White RGB, alpha = source luminance */}
          <feColorMatrix type="matrix" values="0 0 0 0 1  0 0 0 0 1  0 0 0 0 1  0.2126 0.7152 0.0722 0 0" data-id="element-47" data-mp="156k2mzeu5phb" />
          {/* Hard threshold: keep only the light shape */}
          <feComponentTransfer data-id="element-48" data-mp="1e55j8p0qyufg">
            <feFuncA type="discrete" tableValues="0 1" data-id="element-49" data-mp="1e3ui6wyos0s1" />
          </feComponentTransfer>
        </filter>
        <mask id={maskId} maskUnits="userSpaceOnUse" x="0" y="0" width="972" height="972" data-id="element-50" data-mp="1iyi7gy1ikz7o">
          <image href={brandLogoSrc} x="0" y="0" width="972" height="972" filter={`url(#${filterId})`} data-id="element-51" data-mp="1nxur79x39q61" />
        </mask>
      </defs>
      <rect x="0" y="0" width="972" height="972" fill="currentColor" mask={`url(#${maskId})`} data-id="element-52" data-mp="1xu7mgc8a8c2w" />
    </svg>;
}